import * as React from 'react';

import {IframeComponent} from 'shells/iframe/iframe-component';
import {PageTitleBar} from 'shells/layout/page-title-bar';

import {PageContainer} from '../../../layout/page-container';

export function MarketingServicesPage() {
    return (
        <PageContainer
            title='Digital marketing services'
            noPadding={true}
            pageTitleBar={
                <PageTitleBar
                    title='Digital marketing services'
                    subheaderPrimaryText='Partner with WebFX, Nutshell’s parent company, to drive more leads for your business.'
                />
            }
        >
            <IframeComponent
                src='https://www.nutshell.com/digital-marketing-services-free-audit'
                title='Marketing consultation'
            />
        </PageContainer>
    );
}
